"use strict"

function full(){
    document.addEventListener('DOMContentLoaded', showContent)

    bgSize()

    function bgSize(){
        const main = document.querySelector('main')
        const height = main.getBoundingClientRect().height
        
        document.querySelector('.bg').style.height = height+"px"
    }

    window.addEventListener('resize', bgSize)
    const bg = document.querySelector('.bg')

    window.addEventListener('scroll', (e) =>{
        bg.style.backgroundPositionY =  Math.round((window.scrollY * 0.5))+"px"
    })


    let boutonjoin = document.querySelector('#boutonjoin')
    boutonjoin.addEventListener('click', (e) =>{
        window.scrollTo(0,document.body.scrollHeight)
    })

    let burger = document.querySelector('.burger')
    burger.addEventListener('click', (e)=>{
        menu()
    })

    let links = document.querySelectorAll('.menu__el')
    links.forEach(element =>{
        element.addEventListener('click', (e)=>{
            menu()
            
        })
    })

    function addActive(event){
        document.querySelector('.link--actif').classList.remove('link--actif')
        event.target.classList.add('link--actif')
    }

    function menu(){
        document.querySelector('.burger').classList.toggle('burger--selected')
        document.querySelector('.menu').classList.toggle('menu--open')
        document.body.classList.toggle('menu--bodylock')
    }

    const head = document.querySelector(".header")

    let oldscrollY = 0;
    let offsetY = 150;

    window.addEventListener("scroll", (e) => {
        if( oldscrollY > window.scrollY || offsetY > window.scrollY){
          head.classList.remove("header--hidden")
        }
        else{
            head.classList.add("header--hidden");
        }
        oldscrollY = window.scrollY;
    });

    window.addEventListener('hashchange', showContent)

    function showContent(event){
    	window.location.hash = window.location.hash === "" ? "#accueil" : window.location.hash

        document.querySelector('.link--actif').classList.remove('link--actif')
        document.querySelector(`.link[href="${window.location.hash}"]`).classList.add('link--actif')

    	const currentContent = document.querySelector('.section--open')
    	const newContent = document.querySelector(window.location.hash)
    	currentContent.classList.remove('section--open')
    	newContent.classList.add('section--open')
        bgSize()
        window.scrollTo(0,0)
    }

    localStorage.getItem("name") && suscribe()

    let inputs = document.querySelectorAll('.form__input')
    let envoi = document.querySelector('#bouton')
    let form = document.querySelector('.form')

    envoi.addEventListener('click', (e) =>{
        e.preventDefault()
        form.reportValidity()
        if (form.checkValidity() === true) {
            localStorage.setItem("name", inputs[0].value)
            suscribe()
        }
        else{
            for (const input of inputs) {
                if (input.checkValidity() == false) {
                    input.style.color = "red";
                }
            }
        }
    })

    function suscribe(){
        let name = document.querySelector('.name')
        name.textContent = localStorage.getItem("name")
        document.querySelector('.box--open').classList.remove('box--open')
        document.querySelector('.box--deux').classList.add('box--open')
    }

    const $origamiButtons = document.querySelectorAll('.bouton--origami')
    const $origamiArea = document.querySelector('.section--four')

    const getData = url => {
      return fetch(`assets/data/${url}.json`)
        .then(response => response.json())
        .then(data => data)
    }

    const createOrigamiSection = instruction => {
        const template = origamiTemplate(instruction)
        $origamiArea.append(template)
    }

    const origamiStepsTemplate = steps => {
        const $template = document.createElement('ul')
        Object.values(steps).forEach(step => {
            $template.innerHTML += `<li class="origamisinstructions__el">
            <img class="image image--instruction" src="${step.svg}">
            <p>${step.instructions}</p>
            </li>`
        })
        return $template.innerHTML
    }

    const origamiTemplate = origami => {
      const $template = document.createElement('template')
      const steps = origamiStepsTemplate(origami.instru)

      $template.innerHTML =
      `<div class="origamiContent__page" data-section="${origami.title.toLowerCase()}">
            <button class="bouton bouton--arrow"><img class=" arrow bouton--back" src="assets/images/arrow.png"></button>
            <h2 class="title title--name">${origami.title}</h2>
            <img class="image image--resultat" src="${origami.img}" srcet="${origami.imgx2}"/>
            <ul class="origamisinstructions">${steps}</ul>
            <p>Vous avez réussi ?</p>
            <a class=" link bouton bouton--origami" target="_blank" href="https://www.instagram.com/paper.trash.tfa/?hl=fr"> Partagez votre création</a>
        </div>`

      return $template.content.firstChild
    }

    let sectiontrois = document.querySelector('.section--three')

    getData('instructions').then(data => { data.forEach(createOrigamiSection) })

    const displayOrigamiSection = $button => {
        const display = event => {

            const { origami } = event.target.dataset
            const $currentDisplayed = $origamiArea.querySelector('.section--open')
            const $toDisplay = $origamiArea.querySelector(`*[data-section="${origami}"]`)
            $currentDisplayed !== null && $currentDisplayed.classList.remove('section--open')
            $toDisplay.classList.add('isvisible')
            sectiontrois.classList.remove('section--open')
            $origamiArea.classList.add('section--open')
            bgSize()
            window.scrollTo(0,0)

            const boutonbacks = document.querySelectorAll('.bouton--back')

            for (const boutonback of boutonbacks) {
                boutonback.addEventListener('click', e =>{
                    $toDisplay.classList.remove('isvisible')
                    $origamiArea.classList.remove("section--open")
                    sectiontrois.classList.add('section--open')
                    bgSize()
                    window.scrollTo(0,0)
                })
            }

            const arrowbacks = document.querySelectorAll(".arrow")

            for (const arrowback of arrowbacks) {
                let oldscrollYdeux = 0;
                let offsetYdeux = 150;

                window.addEventListener("scroll", (e) => {
                    if( oldscrollYdeux > window.scrollY || offsetYdeux > window.scrollY){
                      arrowback.classList.remove("arrow--hidden")
                    }
                    else{
                        arrowback.classList.add("arrow--hidden")
                    }
                    oldscrollYdeux = window.scrollY
                });
            }
        }

        $button.addEventListener('click', display)
    }

    $origamiButtons.forEach(displayOrigamiSection)
}

function simplify () {

    bgSize()

    function bgSize(){
        const main = document.querySelector('main')
        const height = main.getBoundingClientRect().height
        
        document.querySelector('.bg').style.height = height+"px"
    }

    window.addEventListener('resize', bgSize)

    const bg = document.querySelector('.bg')
}

const { namespaces } = document.body.dataset
const pages = {
    full: () => full(),
    simplify: () => simplify()
}

document.addEventListener('DOMContentLoaded', pages[namespaces]())